"use client";

import { useEffect } from "react";
import { track } from "@/lib/directory-tracking";

// Cliente pequeño que dispara `not_found_view` al mount. Se embebe
// dentro de los server components `not-found.tsx`. dedupKey por
// pathname para no duplicar cuando el user permanece en la 404.
//
// Filtra assets internos (`/_next/*`, `/api/*`, extensiones de
// imagen) — Next Image Optimizer y otros pipelines de asset caen a
// `not-found.tsx` cuando el recurso no existe, y no queremos ensuciar
// la métrica de "rutas rotas del sitio" con eso. Solo trackea
// pathnames que un humano navegaría.
const IGNORE_PREFIXES = ["/_next/", "/api/"];
const ASSET_EXT_RE = /\.(png|jpg|jpeg|webp|gif|svg|ico|avif|css|js|map|txt|xml|json|woff|woff2|ttf|otf|mp4|webm|mp3|wav|pdf)$/i;

export default function Track404() {
  useEffect(() => {
    const path = typeof location !== "undefined" ? location.pathname : "";
    if (!path) return;
    if (IGNORE_PREFIXES.some((p) => path.startsWith(p))) return;
    if (ASSET_EXT_RE.test(path)) return;
    track("not_found_view", {
      dedupKey: path,
      metadata: { path },
    });
  }, []);
  return null;
}
